import { Box } from '@mui/material';
import { InputRow } from '../InputRow';
import { LimeInstanceInputs } from './LimeInstanceInputs';
import { PhosphorusPotassiumInstanceInputs } from './PhosphorusPotassiumInstanceInputs';

export function InstanceInputs({ instance }) {
  return (
    <Box data-testid="instance-inputs">
      <LimeInstanceInputs rx={instance?.fields[0]?.lime} />
      <PhosphorusPotassiumInstanceInputs
        type="P"
        rx={instance?.fields[0]?.phosphorus}
      />
      <PhosphorusPotassiumInstanceInputs
        type="K"
        rx={instance?.fields[0]?.potassium}
      />
      <InputRow
        name="Number of Cropping Years"
        value={firstFieldProperty('numberOfCroppingYears')}
      />
      <InputRow
        name="Years to Critical"
        value={firstFieldProperty('yearsToCritical')}
      />
    </Box>
  );

  function firstFieldProperty(property) {
    return ['lime', 'phosphorus', 'potassium']
      .map((name) => instance.fields[0]?.[name]?.[property])
      .filter(Boolean)
      .at(0);
  }
}
